"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetamaskService = void 0;
const tsyringe_1 = require("tsyringe");
const networkInfos_helper_1 = require("../../../../helpers/networkInfos/networkInfos.helper");
const required_1 = require("../../../../helpers/required/required");
let MetamaskService = class MetamaskService {
    constructor() {
        this.currentChainId = 137;
        this.initMetamaskSilently = () => __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            if (this._window.ethereum) {
                this.hasMetamask = true;
                const isMMUnlock = yield this._window.ethereum._metamask.isUnlocked();
                if (isMMUnlock) {
                    yield this.initMetamask();
                }
            }
        });
        this.getInstallationLink = (dappUrl) => {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            required_1.required(!dappUrl.includes('https'), 'You need to pass the url without the protocol');
            const isMobile = this.mobileAndTabletCheck();
            if (isMobile) {
                return `https://metamask.app.link/dapp/${dappUrl}`;
            }
            return 'https://metamask.io/';
        };
        this.initMetamask = () => __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            if (this._window.ethereum) {
                this.accounts = yield this._window.ethereum.request({ method: 'eth_requestAccounts' });
                this.defaultAccount = this.accounts[0];
                this.currentChainId = this._window.ethereum.chainId;
            }
        });
        this.switchToNetwork = (network) => __awaiter(this, void 0, void 0, function* () {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            const networkInfo = yield networkInfos_helper_1.getNetworkInfo(network);
            this._window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [{
                        chainId: `0x${networkInfo.chainId.toString(16)}`,
                        chainName: networkInfo.name,
                        rpcUrls: networkInfo.rpc,
                        nativeCurrency: networkInfo.nativeCurrency,
                        blockExplorerUrls: networkInfo.explorers.map(explorer => explorer.url)
                    }]
            });
        });
        this.signData = (data) => {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            return this._window.ethereum.request({
                method: 'personal_sign',
                params: [this.defaultAccount, data]
            });
        };
        this.signDatav4 = (data) => {
            required_1.requiredDefined(this._window, "You can't use metamask on nodejs");
            const payload = JSON.stringify(data);
            return this._window.ethereum.request({
                method: 'eth_signTypedData_v4',
                params: [this.defaultAccount, payload]
            });
        };
        if (typeof window !== 'undefined') {
            this._window = window;
        }
    }
    mobileAndTabletCheck() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    ;
};
MetamaskService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [])
], MetamaskService);
exports.MetamaskService = MetamaskService;
//# sourceMappingURL=metamaskService.js.map